import { Fragment, useCallback, useEffect, useMemo } from 'react'
import { createPortal } from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'
import { resetLnb, setLnbOver, toggleExpanded } from 'features/lnb/lnbSlice'
import AdAccountFinder from 'features/lnb/AdAccountFinder'
import { MenuGroup, MenuLink } from 'features/lnb/MenuGroup'
import AdAccountManager from 'features/lnb/AdAccountManager'
import { useParams } from 'react-router-dom'
import useLnbHeight from './useLnbHeight'
import useLayoutClass from '../layout/useLayoutClass'
import { addLayoutClass, removeLayoutClass } from '../layout/layoutSlice'

const Lnb = () => {
  const root = document.getElementById('mFeature')
  const dispatch = useDispatch()
  const { accountId } = useParams()
  const { isExpanded, isOver } = useSelector(state => state.lnb)
  const { accountRef, menuRef, menuHeight } = useLnbHeight()
  const assetItems = useMemo(
    () => [
      {
        title: '비즈채널 관리',
        to: `/${accountId}/channels`,
      },
      {
        title: '심사서류 관리',
        to: `/${accountId}/documents`,
      },
      {
        title: '광고소재 관리',
        to: `/${accountId}/creatives`,
      },
      {
        title: '키워드 플래너',
        to: `/${accountId}/keyword-planner`,
      },
      {
        title: '대량 관리',
        prefix: `/${accountId}/bulks`,
        to: `/${accountId}/bulks/download`,
      },
      {
        title: '이미지 관리',
        to: `/${accountId}/images`,
      },
      {
        title: '픽셀&SDK 연동 관리',
        to: `/${accountId}/tracker`,
      },
      {
        title: '광고노출 제한',
        to: `/${accountId}/restrict-ip`,
      },
    ],
    [accountId]
  )
  const settingItems = useMemo(
    () => [
      {
        title: '광고계정 관리',
        to: `/${accountId}/settings/adaccount`,
      },
      {
        title: '비즈월렛 관리',
        to: `/${accountId}/settings/bizwallet`,
      },
      {
        title: '변경이력 관리',
        to: `/${accountId}/editlog`,
      },
    ],
    [accountId]
  )
  useLayoutClass(isExpanded ? 'lnb_on' : '')

  const handleMouseEnter = useCallback(() => {
    if (!isOver) dispatch(setLnbOver(true))
  }, [isOver, dispatch])
  const handleMouseLeave = useCallback(() => {
    if (isOver) dispatch(setLnbOver(false))
  }, [isOver, dispatch])

  useEffect(
    () => () => {
      dispatch(resetLnb())
    },
    [dispatch]
  )
  useEffect(() => {
    if (isExpanded) {
      dispatch(addLayoutClass('lnb_on'))
    } else {
      dispatch(removeLayoutClass('lnb_on'))
    }
  }, [dispatch, isExpanded])
  useEffect(() => {
    if (isOver) {
      dispatch(addLayoutClass('lnb_over'))
    } else {
      dispatch(removeLayoutClass('lnb_over'))
    }
  }, [dispatch, isOver])

  return root ? (
    createPortal(
      <>
        <div
          className="feature_wrap"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}>
          <div className="cont_info">
            <div className="account_info">
              <AdAccountFinder ref={accountRef} />
              <AdAccountManager />
            </div>
          </div>
          <nav className="cont_snb">
            <ul
              ref={menuRef}
              className="list_snb"
              style={{ height: menuHeight }}>
              <MenuLink
                prefix={`/${accountId}/dashboard`}
                to={`/${accountId}/dashboard`}
                className="link_snb">
                <span className="ico_gnb ico_snb1" />
                대시보드
              </MenuLink>
              <MenuLink
                prefix={`/${accountId}/ads`}
                to={`/${accountId}/ads/campaigns/new?from=campaign`}
                className="link_snb">
                <span className="ico_gnb ico_snb2" />
                광고 만들기
              </MenuLink>
              <MenuLink to={`/${accountId}/report`} className="link_snb">
                <span className="ico_gnb ico_snb3" />
                보고서
              </MenuLink>
              <MenuGroup
                title={
                  <>
                    <span className="ico_gnb ico_snb4" />
                    광고자산 관리
                  </>
                }
                items={assetItems}
              />
              <MenuGroup
                title={
                  <>
                    <span className="ico_gnb ico_snb6" />
                    설정
                  </>
                }
                items={settingItems}
              />
            </ul>
          </nav>
        </div>
        <div className="fold_btn">
          <button
            type="button"
            className="btn_opcl"
            onClick={() => dispatch(toggleExpanded())}>
            <span className="ico_gnb">펼침/닫힘</span>
          </button>
        </div>
      </>,
      root
    )
  ) : (
    <Fragment />
  )
}
export default Lnb
